<template>
  <div id="PositionDesign">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'positionDesign'
}
</script>

<style>
#PositionDesign {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/booth/design/PositionDesign.vue